import { AlertTriangle, Loader2, Wand2 } from "lucide-react";
import { MIX_PHASES, TRACK_LABELS, audibleTracks } from "@/lib/mixDeskApi";

const ORDER = ["starting", "loading", "mixing", "saving"];

function Progress({ phase }) {
  const at = Math.max(0, ORDER.indexOf(phase));
  return (
    <div data-testid="mix-render-progress" data-phase={phase} className="mt-4 space-y-2">
      <p className="flex items-center gap-2 text-sm text-amber-100"><Loader2 className="h-4 w-4 animate-spin" /> <span data-testid="mix-render-phase">{MIX_PHASES[phase] || "Working"}…</span></p>
      <div className="flex gap-1.5">{ORDER.map((p, i) => <span key={p} className={`h-1 flex-1 rounded-full transition-colors duration-500 ${i <= at ? "bg-amber-300" : "bg-white/10"}`} />)}</div>
      <p className="text-[11px] text-white/45">Usually under a minute. You can leave this page — the mix keeps going and lands in the list below.</p>
    </div>
  );
}

/** What goes into the final mix, and the big Render button. */
export default function RenderPanel({ settings, names, presetLabel, render, running, starting, onRender }) {
  const live = audibleTracks(settings.tracks, names);
  const none = live.length === 0;
  return (
    <section data-testid="mix-render-panel" className="rounded-3xl border border-amber-300/25 bg-gradient-to-br from-amber-500/[0.10] via-[#0a0d1c]/90 to-[#0a0d1c]/90 p-5">
      <p className="font-display text-lg font-semibold">Render the final song</p>
      <p data-testid="mix-render-summary" className="mt-1 text-[12px] leading-relaxed text-white/60">
        {none ? "Every part is muted — turn at least one on." : `${live.map((n) => TRACK_LABELS[n] || n).join(" · ")} → ${presetLabel}`}
      </p>
      <button type="button" data-testid="mix-render-btn" onClick={onRender} disabled={running || starting || none}
        className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-r from-amber-300 to-orange-500 px-6 py-3 font-display text-sm font-semibold text-[#05070f] transition-transform duration-200 hover:scale-[1.02] disabled:opacity-40 disabled:hover:scale-100">
        {running || starting ? <Loader2 className="h-4 w-4 animate-spin" /> : <Wand2 className="h-4 w-4" />} {running ? "Rendering…" : "Render WAV + MP3"}
      </button>
      {running || starting ? <Progress phase={running ? render?.phase : "starting"} /> : null}
      {render?.status === "error" ? (
        <p data-testid="mix-render-error" className="mt-4 flex items-start gap-2 rounded-2xl border border-rose-400/40 bg-rose-500/10 px-3 py-2.5 text-[12px] text-rose-100">
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />{render.error}
        </p>
      ) : null}
    </section>
  );
}
